export const DEPTH_SHAPE = 0
export const DEPTH_FRONTBACK = 1
export const DEPTH_COUNT = 2

export const LAYER_VOLUME = 1
export const LAYER_SHAPE = 2
//export const LAYER_CROPBOX = 4
export const RENDERMODE = 1
